export enum RequestPaths {
  ChooseCourt = 'choose-court',
  CourtSystem = 'court-system',
  Recordings = 'recordings',
  Transcripts = 'transcripts',
}

export enum RequestParams {
  RequestType = 'requestType',
  CourtSystemId = 'courtSystemId',
}
